import { gql } from '@apollo/client/core';

const CREATE_SESSION_STRUCTURE = gql`
  mutation CreateSessionStructure($input: CreateSessionStructureInput!) {
    createSessionStructure(input: $input) {
      id
      school_id
      name
      description
      is_default
      created_at
      updated_at
      termsStructure {
        id
        session_structure_id
        name
        sequence
        created_at
        updated_at
        sessionStructure {
          id
          school_id
          name
          description
          is_default
          created_at
          updated_at

          sessions {
            id
            name
            started_at
            ended_at
            created_at
            updated_at
          }
        }
        academicCalendars {
          id
          school_id
          session_id
          term_structure_id
          started_at
          ended_at
          is_active
          total_school_days
          next_calender_starts_at
          created_at
          updated_at
        }
      }
      sessions {
        id
        name
        started_at
        ended_at
        created_at
        updated_at
      }
    }
  }
`;

const CREATE_SESSION = gql`
  mutation CreateSession($input: CreateSessionInput!) {
    createSession(input: $input) {
      id
      name
      started_at
      ended_at
      created_at
      updated_at

    }
  }
`;

const CREATE_TERM_STRUCTURE = gql`
  mutation CreateTermStructure($input: CreateTermStructureInput!) {
    createTermStructure(input: $input) {
      id
      session_structure_id
      sequence
      name
      created_at
      updated_at
      sessionStructure {
        id
        school_id
        name
        description
        is_default
        created_at
        updated_at

        sessions {
          id
          name
          started_at
          ended_at
          created_at
          updated_at
        }
      }
      academicCalendars {
        id
        school_id
        session_id
        term_structure_id
        started_at
        ended_at
        is_active
        total_school_days
        next_calender_starts_at
        created_at
        updated_at
      }
    }
  }
`;

const CREATE_ACADEMIC_CALENDAR = gql`
  mutation CreateAcademicCalendar($input: CreateAcademicCalendarInput!) {
    createAcademicCalendar(input: $input) {
      id
      started_at
      ended_at
      is_active
      total_school_days
      next_calender_starts_at
      created_at
      updated_at
      session {
        id
        name
      }
      termStructure {
        id
        name
      }
    }
  }
`;

// GraphQL Mutation for Deleting a Session Structure
const DELETE_SESSION_STRUCTURE = gql`
  mutation DeleteSessionStructure($id: ID!) {
    deleteSessionStructure(id: $id) {
      id
      name
    }
  }
`;

const CREATE_SECTION = gql`
  mutation CreateSection($input: CreateSectionInput!) {
    createSection(input: $input) {
      id
      name
    }
  }
`;

const CREATE_CLASSROOM_SECTION = gql`
  mutation CreateClassroomSection($input: CreateClassroomSectionInput!) {
    createClassroomSection(input: $input) {
      id
      name
    }
  }
`;

const CREATE_CLASSROOM = gql`
  mutation CreateClassroom($input: CreateClassroomInput!) {
    createClassroom(input: $input) {
      id
      name
      abbreviation
      sequence
    }
  }
`;

const UPDATE_CLASSROOM_SECTION = gql`
  mutation UpdateClassroomSection($id: ID!, $input: UpdateClassroomSectionInput!) {
    updateClassroomSection(id: $id, input: $input) {
      id
      name
      classroom {
        id
        name
      }
      section {
        id
        name
      }
    }
  }
`;

const UPDATE_CLASSROOM = gql`
  mutation UpdateClassroom($id: ID!, $input: CreateClassroomInput!) {
    updateClassroom(id: $id, input: $input) {
      id
      name
      abbreviation
      sequence
    }
  }
`;

const SET_ACTIVE_ACADEMIC_CALENDAR = gql`
  mutation SetActiveAcademicCalendar($id: ID!) {
    setActiveAcademicCalendar(id: $id) {
        id
        school_id
        session_id
        term_structure_id
        started_at
        ended_at
        is_active
        total_school_days
        next_calender_starts_at
        created_at
        updated_at
        session {
          id
          name
        }
        termStructure {
          id
          name
        }
    }
  }
`;

const UPDATE_SESSION = gql`
  mutation UpdateSession($input: UpdateSessionInput!) {
    updateSession(input: $input) {
      id
      name
      started_at
      ended_at
      created_at
      updated_at
      sessionStructure {
        id
        name
      }
    }
  }
`;

const UPDATE_ACADEMIC_CALENDAR = gql`
  mutation UpdateAcademicCalendar($input: UpdateAcademicCalendarInput!) {
    updateAcademicCalendar(input: $input) {
      id
      started_at
      ended_at
      is_active
      total_school_days
      next_calender_starts_at
      created_at
      updated_at
      session {
        id
        name
      }
      termStructure {
        id
        name
      }
    }
  }
`;

export {
  CREATE_SESSION_STRUCTURE,
  CREATE_SESSION,
  CREATE_TERM_STRUCTURE,
  DELETE_SESSION_STRUCTURE,
  CREATE_ACADEMIC_CALENDAR,
  CREATE_SECTION,
  CREATE_CLASSROOM_SECTION,
  CREATE_CLASSROOM,
  UPDATE_CLASSROOM_SECTION,
  UPDATE_CLASSROOM,
  SET_ACTIVE_ACADEMIC_CALENDAR,
  UPDATE_SESSION,
  UPDATE_ACADEMIC_CALENDAR,
};
